import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { TextBox } from "../../core/components/textBox";
import { CheckBox } from "../../core/components/checkBox";
import { FieldInstance } from "../../core/components/field";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslations from "../editTranslations";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react"

export default class EditProjectStatus extends React.Component<{ context: ContextGeneralSettingsApp}, EditProjectStatusState> {
    private _translations: string[] = null;
    private _options: any = null;
    private _editTranslationsRef: EditTranslations = null;
    private _factory = ComponentHelper.createFactory();
    private _nextId: number;
    private _fullLoaded: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._checkData()) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._fullLoaded = false;
        this.state = { gridData: [], deleteButtonEnabled: false, dialogOpen: false, currentItem: null };
    }

    private _checkData = () => {
        return !Helper.isNullOrEmpty(this.state.currentItem.Name);;
    }

    private _getGridData = () => {
        let url = "ProjectSettings/GetAllStatus";
        HTTPService.get<JsonResultClass<Status[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this._nextId = result.AdditionalData["NextId"];
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _save = () => {
        let url = "ProjectSettings/SaveStatus";
        HTTPService.post<JsonResultClass>(url, { model: this.state.currentItem }).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this._createTextBox()}
                            {this._createTranslationLabel()}
                            {this._createCheckBox("EditReport")}
                            {this._createCheckBox("EditFaktura")}
                            {this._createCheckBox("EditProject")}
                            {this._createCheckBox("AssigmentGeneration")}
                        </FullHeightContainer>
                        <EditTranslations
                            ref={(r) => this._editTranslationsRef = r}
                            label={Config.translations.editLabel}
                            saveGerman={(value: string) => {
                                let item = this.state.currentItem;
                                item.GermanName = value;
                                this.setState({ currentItem: item });
                            }}
                        />
                    </Dialog>                
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private _createTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentItem.Name;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.Name = value;
            this.setState({ currentItem: item });
        }
        return (
            <FieldInstance label={this._translations["Standard.Name"] + "*"} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _createCheckBox = (type: "EditReport" | "EditFaktura" | "EditProject" | "AssigmentGeneration") => {
        let props = this._factory.getDefaultCheckBoxProps();
        let label = "";
        switch (type) {
            case "EditReport":
                props.value = this.state.currentItem.EditReport;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let item = this.state.currentItem;
                    item.EditReport = value;
                    this.setState({ currentItem: item });
                }
                label = this._translations["WebSMS.GeneralSettings.Project.Status.ReportAcquisition"];
                break;
            case "EditFaktura":
                props.value = this.state.currentItem.EditFaktura;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let item = this.state.currentItem;
                    item.EditFaktura = value;
                    this.setState({ currentItem: item });
                }
                label = this._translations["WebSMS.GeneralSettings.Project.Status.Settlement"];
                break;
            case "EditProject":
                props.value = this.state.currentItem.EditProject;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let item = this.state.currentItem;
                    item.EditProject = value;
                    this.setState({ currentItem: item });
                }
                label = this._translations["WebSMS.GeneralSettings.Project.Status.Editing"];
                break;
            case "AssigmentGeneration":
                props.value = this.state.currentItem.AssigmentGeneration;
                props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                    let item = this.state.currentItem;
                    item.AssigmentGeneration = value;
                    this.setState({ currentItem: item });
                }
                label = this._translations["WebSMS.GeneralSettings.Project.Status.AssignmentGeneration"];
                break;
        }

        return (
            <FieldInstance label={label} noHover={true} labelStyle={{ width:"200px" }}>
                <CheckBox {...props} />
            </FieldInstance>
        );

    } 

    private _createTranslationLabel = () => {
        if (!this.state.currentItem.IsNew) {
            const labelStyle: React.CSSProperties = {
                cursor: "pointer",
                textDecoration: "Underline"
            }
            const divStyle: React.CSSProperties = {
                display: "flex",
                justifyContent: "flex-end",
                fontSize: "10px",
                marginTop: "2px"
            }
            return (
                <FieldInstance noLabel={true}>
                    <div style={divStyle}>
                        <label
                            style={labelStyle}
                            onClick={this._openTranslationsDialog}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}
                        </label>
                    </div>
                </FieldInstance>);
        } else {
            return <></>;
        }
    }

    private _openTranslationsDialog = () => {
        this._editTranslationsRef.openDialog(this.state.currentItem.IsRowId, 45, "value_0", this.state.currentItem.GermanName);
    }

    private _delete = (dataItem: Status) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "ProjectSettings/DeleteStatus";
                HTTPService.post<JsonResultClass>(url, { model: dataItem }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = (dataItem: Status = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Id: this._nextId,
                Name: "",
                GermanName: "",
                EditReport: true,
                EditFaktura: true,
                EditProject: true,
                AssigmentGeneration : true,
                IsRowId: 0,
                IsDeleteable: true,
                IsNew: true,
            };
        }
        this.setState({ dialogOpen: true, currentItem: dataItem })
    }

    private _createGrid = () => {

        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteButtonEnabled });
            let grid = (
                <Grid data={this.state.gridData} options={this._options} id="generalSettings_ProjectStatusGrid" onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: Status) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ deleteButtonEnabled: dataItem.IsDeleteable });
        }
        else
            this.setState({ deleteButtonEnabled: false });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Status) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog()
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._translations = this.props.context.translations;
        this._options = this.props.context.projectStatusGridOptions;
        this._fullLoaded = true;
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this._createDialog();
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};


interface EditProjectStatusState {
    dialogOpen: boolean;
    deleteButtonEnabled: boolean;
    currentItem: Status;
    gridData: Status[];
}

interface Status {
    Id: number;
    Name: string;
    GermanName: string;
    EditReport: boolean;
    EditFaktura: boolean;
    EditProject: boolean;
    AssigmentGeneration: boolean;
    IsRowId: number;
    IsNew: boolean;
    IsDeleteable: boolean;
}